<template>
    <div class="thank-you__details__wrapper bordered-box__wrapper">
        <h3>Delivery</h3>
        <h4>Delivery location</h4>
        <div class="thank-you__details__map">
            <iframe class="rounded" width="100%" height="150" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" :src="mapSrc"></iframe>
        </div>
        <div class="thank-you__details__address message-box">
            <div class="message-box__label">
                <h4>{{ customer }}</h4>
                {{ delivery_to }}
            </div>
        </div>
    </div>
</template>
<script setup>

import {useCart} from '@/frontend/vue/composables/useCart'
import {computed, onMounted} from 'vue'

const props = defineProps({
    order: { type: Object, required: true },
    address: { type: String, required: true },
    store: { type: String, required: true },
})

const customer = computed(() => {
    return props.order.metadata.user.first_name + ' ' + props.order.metadata.user.last_name;
});

const delivery_to = computed(() => {
    return props.order.metadata.user.address + ', ' + props.order.metadata.user.suburb + ', ' + props.order.metadata.user.state + ', ' + props.order.metadata.user.postcode;
});

const mapSrc = computed(() => {
    const base = 'https://maps.google.com/maps'
    const params = new URLSearchParams({
        width: '100%',
        height: '200',
        hl: 'en',
        q: delivery_to.value,
        t: '',
        z: '14',
        ie: 'UTF8',
        iwloc: 'B',
        output: 'embed'
    })
    return `${base}?${params.toString()}`
})

onMounted(() => {
    resetCart();
})

const {
    resetCart
} = useCart()

</script>
